export default __webpack_public_path__ + "static/media/16-min.a25d0f1b.jpg";